<ppl-accordion [title]="''" [isOpen]="true">
    <div class="">
        Benefits information will be available soon
    </div>
</ppl-accordion>